/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "master",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#454545"
            },
            "master": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "43",
            "height": "18"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 43 18", className: "master", width: this.props.width, height: this.props.height, style: this.props.master },
            _react2["default"].createElement("path", { className: "st0", d: "M9 0C4 0 0 4 0 9s4 9 9 9 9-4 9-9-4-9-9-9zm5 12.7v.1l-.1.1c-.1 0-.1 0-.3.1h-.8c-.1 0-.2 0-.3-.1-.1 0-.1-.1-.1-.1v-7l-2.5 6.9c0 .1 0 .1-.1.1 0 0-.1.1-.2.1h-.3c-.1 0-.2.1-.3.1h-.4c-.1 0-.2 0-.3-.1-.1 0-.1-.1-.2-.1l-.1-.1-2.3-6.9v7l-.1.1s-.2 0-.3.1h-.8c-.1 0-.2 0-.3-.1-.1 0-.1-.1-.1-.1V5.1c0-.2.1-.4.2-.5s.3-.2.5-.2h1.6c.1 0 .3.1.4.2s.1.2.2.3c.1.1.1.3.2.5L9 10.5l2-5.1c.1-.2.1-.3.2-.5.1-.1.1-.2.2-.3.1-.1.2-.1.3-.2H13.6c.1 0 .2.1.2.1.1.1.1.1.1.2v8zM23 7.2c-.2-.2-.4-.3-.7-.4s-.6-.1-1.1-.1c-.2 0-.5 0-.7.1s-.4.1-.6.1-.3.1-.5.2-.2.1-.3.2 0 .1-.1.2 0 .2 0 .3v.4c0 .1 0 .1.1.1h.1c.1 0 .1 0 .2-.1s.2-.1.4-.2.3-.1.5-.2.4-.1.7-.1c.2 0 .3 0 .5.1s.2.1.3.2.2.2.2.4v.7h-.5c-.5 0-.9 0-1.2.1l-.9.3c-.3.1-.4.3-.5.6s-.2.5-.2.8c0 .3 0 .5.1.7s.2.4.4.5l.6.3c.2.1.5.1.8.1.3 0 .6-.1.9-.2s.5-.3.7-.5v.5s.1.1.2.1h.8c.1 0 .1 0 .2-.1l.1-.1V8.8c0-.4 0-.7-.1-.9s-.2-.5-.4-.7zm-.9 3.7l-.5.5c-.1.1-.4.2-.6.2-.2 0-.4-.1-.6-.2s-.2-.3-.2-.5c0-.1 0-.2.1-.3s.1-.2.2-.3.2-.1.4-.2.4-.1.6-.1h.6v.9zM28.3 9.7c-.1-.1-.3-.2-.4-.3s-.3-.2-.5-.2-.3-.1-.5-.2-.3-.1-.4-.2-.2-.1-.3-.2-.1-.2-.1-.3v-.2s.1-.1.1-.2.1-.1.2-.1h.3c.2 0 .4 0 .5.1s.3.1.4.1.4 0 .4.1.1.1.2.1h.1l.1-.1c.1-.1 0-.1 0-.2v-.3-.2-.2-.1s0-.1-.1-.1-.2 0-.3-.1-.2-.1-.3-.1-.3-.1-.4-.1h-.5c-.3 0-.6 0-.9.1s-.5.2-.6.4-.3.3-.4.5-.1.4-.1.7c0 .2 0 .5.1.6s.2.3.3.5.3.2.4.3.2.2.4.2.3.1.5.2.3.1.4.2.2.1.3.2.1.2.1.3c0 .1 0 .2-.1.3l-.2.2c-.1.1-.2.1-.3.1h-.4c-.2 0-.4 0-.6-.1s-.3-.1-.4-.2-.2-.1-.3-.2-.1 0-.1 0h-.1l-.1.1c-.1.1 0 .1 0 .2v.7c0 .1.1.2.1.2s.1.1.2.1.2.1.4.1.3.1.5.1h.6c.3 0 .6 0 .9-.1s.5-.2.7-.3.4-.3.5-.6.2-.5.2-.8c0-.2 0-.4-.1-.6s-.3-.3-.4-.4zM32.5 8c.1 0 .1 0 .2-.1s.1-.2.1-.5v-.3-.2c0-.1 0-.1-.1-.1H31.5V5.7v-.1l-.1-.1h-1.2s-.1 0-.1.1v1.3h-.6-.1s-.3 0-.3.1v.5c0 .2 0 .4.1.5s0 0 .1 0h.6v2.7c0 .3 0 .6.1.8l.3.6c.1.2.3.3.5.3s.5.1.8.1h.6c.1 0 .2 0 .2-.1s.1-.1.2-.1.1-.1.1-.2v-.4-.3-.2-.1h-.1-.1-.1-.4c-.2 0-.4-.1-.5-.2s-.1-.4-.1-.6V8h1.1zM37.9 7.4c-.2-.2-.5-.4-.8-.5s-.7-.2-1.1-.2c-.4 0-.8.1-1.1.2s-.6.3-.9.6-.4.6-.5.9-.2.8-.2 1.3.1.9.2 1.3.3.7.5.9.5.4.9.5.8.2 1.2.2h.7c.2 0 .4-.1.6-.1s.3-.1.4-.1.2-.1.2-.1 0-.1.1-.1 0-.1 0-.1v-.2-.2-.2-.1s0-.1-.1-.1h-.1c-.1 0-.1 0-.2.1s-.2.1-.4.1-.3.1-.5.1-.4.1-.7.1c-.3 0-.5 0-.7-.1s-.3-.2-.4-.3-.2-.3-.3-.5-.1-.4-.1-.6H38c.1 0 .3 0 .3-.1s.1-.2.1-.4v-.4c0-.4 0-.7-.1-1s-.2-.6-.4-.9zm-3.1 1.7c0-.2 0-.4.1-.5s.1-.3.2-.4l.3-.3c.1-.1.3-.1.5-.1.4 0 .6.1.8.4s.3.6.2 1h-2.1zM43 7.2V7v-.1-.1c0-.1-.1 0-.1-.1s-.1 0-.2 0H42c-.1 0-.2.1-.3.2l-.3.3c-.1.1-.2.3-.4.5V7v-.1l-.1-.1h-1c-.1 0-.1 0-.1.1V12.3l.1.1h1.2s.1 0 .1-.1V9c.1-.2.2-.3.3-.4l.3-.3c.1-.1.2-.1.3-.2s.2 0 .2 0h.7s0-.1.1-.1 0-.1 0-.2v-.3c0-.1-.1-.2-.1-.3z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/master.js